import React from 'react';
import {CardElement} from '@stripe/react-stripe-js';
// import './CardSection.css'

//import styles from './styles.module.css';

import Box from '@material-ui/core/Box';
// import Container from '@material-ui/core/Container';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#ffffff",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

function CardSection({isLoading}) {
  return (
    <label>
      <Box p={4} textAlign="center">{isLoading ? `Submitting...` : `Card Details`}</Box>
      <Box p={4} >
        <CardElement options={CARD_ELEMENT_OPTIONS} />
      </Box>
    </label>
  );
};

export default CardSection;